import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";
import { Stack, Typography } from "@mui/material";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";

const ITEM_HEIGHT = 48;

const CustomMenu = ({ options, disabled, iconColor, transformOrigin, anchorOrigin, item }) => {
  const { bt } = useBizTypeTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.preventDefault()
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onClickMenuItem = (onClick) => {
    if (item)
      onClick(item);
    else
      onClick();

    handleClose();
  };

  return (
    <div>
      <IconButton
        disabled={disabled}
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        sx={{ p: 0 }}
      >
        <MoreVertIcon sx={{ color: iconColor ? iconColor : 'none' }} />
      </IconButton>

      <Menu
        MenuListProps={{ "aria-labelledby": "long-button" }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: anchorOrigin?.vertical ?? "bottom",
          horizontal: anchorOrigin?.horizontal ?? "left",
        }}
        transformOrigin={{
          vertical: transformOrigin?.vertical ?? "top",
          horizontal: transformOrigin?.horizontal ?? "left",
        }}
        PaperProps={{ style: { maxHeight: ITEM_HEIGHT * 10 } }}
      >
        {options?.map((option, index) => {
          return (
            option.show && (
              <MenuItem
                disabled={option?.disabled}
                key={index}
                selected={option === "Pyxis"}
                onClick={() => onClickMenuItem(option.onClick)}
              >
                <Stack
                  direction="row"
                  gap={1}
                  justifyContent="center"
                  alignItems="center"
                >
                  {option.icon}
                  <Typography color={option?.textColor ? option?.textColor : "secondary"} paddingBottom={0.5}>
                    {bt(option.title)}
                  </Typography>
                </Stack>
              </MenuItem>
            )
          );
        })}
      </Menu>
    </div>
  );
};

export default CustomMenu;
